var parseJSON = function (value) {
    if (value === null) {
        return value;
    }
    return JSON.parse(value);
};
var arrayify = function (item) {
    return item instanceof Array ? item : [item];
};
export { parseJSON, arrayify };
